import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import "./ButtonComponent.scss";

const ButtonComponent = ({
  children,
  onClick,
  type = "button",
  className = "",
  disabled = false,
  loading = false,
  variant = "primary",
  style
}) => {
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      className={`custom-button ${variant} ${loading ? "is-loading" : ""} ${className}`}
      onClick={onClick}
      disabled={isDisabled}
      style={style}
    >
      {loading && <LoadingOutlined spin aria-hidden="true" />}
      {children}
    </button>
  );
};

export default ButtonComponent;
